<template>
  <q-btn
    borderless
    color="grey-7"
    :dense="dense"
    :disable="disable"
    flat
    icon="more_vert"
    :padding="btnPadding"
    round
    :size="size"
    type="button"
    @click.stop
  >
    <q-menu auto-close fit @show="$emit('open')">
      <q-list class="text-no-wrap print-hide">
        <slot>
          <q-item
            v-for="(item, index) in items"
            :key="index"
            class="text-right"
            :class="{ [item.class]: item.class }"
            clickable
            style="text-decoration: none"
            :to="item.to ? item.to : undefined"
            @click="item.onClick ? item.onClick($event) : () => {}"
          >
            <q-item-section>{{ item.label }}</q-item-section>
          </q-item>
        </slot>
      </q-list>
    </q-menu>
  </q-btn>
</template>

<script>
export default {
  name: 'KebabMenu',
  props: {
    btnPadding: {
      type: String,
      default: 'sm',
    },
    dense: Boolean,
    disable: Boolean,
    items: Array,
    menuTarget: String,
    size: String,
  },
};
</script>
